import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLinkedin } from "@fortawesome/free-brands-svg-icons";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";

const Contact = () => {
  return (
    <section id="contact" className="py-3">
      <div className="container">
        <h2 className="fw-bold mb-4">Contact</h2>
        <div className="d-flex">
          <div className="line me-4 border-bottom border-5"></div>
          <p className="text">
            <ul className="mt-3" style={{ listStyleType: 'none', paddingLeft: 0 }}>
              <li>
                Let’s connect! Always open to discussion around the latest topics in finance, AI, FinTech, and analytics. Whether you’d like to reach out to discuss my work, projects, or potential opportunities, feel free to reach out!
              </li>
              <li>
                Email: <span> </span>
                <a href="mailto:salmansaeed2112@gmail.com" className="text-primary text-decoration-underline">
                  <FontAwesomeIcon icon={faEnvelope} className="social-icon me-3 fs-6 " />
                  salmansaeed2112@gmail.com
                </a>
              </li>
              <li>
                LinkedIn: <span> </span>
                <a href="https://www.linkedin.com/in/salmansaeed21" target="_blank" rel="noopener noreferrer" className="text-primary text-decoration-underline">
                  <FontAwesomeIcon icon={faLinkedin}  className="social-icon me-3 fs-6 " />
                  linkedin.com/in/salmansaeed21
                </a>
              </li>
            </ul>




            {/* <a
            href="https://www.linkedin.com/in/salmansaeed21"
            target="_blank"
            rel="noopener noreferrer"
            className="contact-link"
          >
            <strong>LinkedIn</strong>
          </a>{" "}
          or{" "}
          <a
            href="mailto:salmansaeed2112@gmail.com"
            target="_blank"
            rel="noopener noreferrer"
            className="contact-link"
          >
            <strong>Email</strong>
          </a>{" "} */}
            {/* .Ask me anything about my work, my projects, or anything else you'd like. */}
          </p>
        </div>

      </div>
    </section>
  );
};

export default Contact;
